<template>
    <CompassInput
        :modelValue="currentValue"
        :disabled="disabled"
        :readonly="readonly"
        :error="error"
        :placeholder="placeholder"
        :size="size"
        @input="handleInput($event)"
        @focus="handleFocus($event)"
        @blur="handleBlur($event)"
        @keyup.enter="handleKeyupEnter($event)"
        @keypress="handleKeyPress($event)"
    >
        <template v-if="currencyPos === 'right'" #suffix>
            {{ currencySymbol }}
        </template>
        <template v-else #prefix>
            {{ currencySymbol }}
        </template>
    </CompassInput>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [Number, String],
            default: NumberFormat.formatToDisplay(0, window.App.numformat),
        },
        size: {
            type: String,
            default: 'medium',
            validator(value) {
                return ['small', 'medium', 'large'].includes(value);
            },
        },
        placeholder: {
            type: String,
            default: '',
        },
        currencySymbol: {
            type: String,
            default: window.App.numformat.currencysymbol,
        },
        currencyPos: {
            type: String,
            default: window.App.numformat.currencypos,
        },
        numberDecimal: {
            type: String,
            default: window.App.numformat.decimals,
        },
        numberThousand: {
            type: String,
            default: window.App.numformat.thousands,
        },
        numberFormat: {
            type: Object,
            default() {
                return window.App.numformat;
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentValue: this.modelValue,
            isFocused: false,
        };
    },
    computed: {
        formatedValue() {
            return NumberFormat.formatToDisplay(this.currentValue, this.numberFormat);
        },
    },
    watch: {
        modelValue(value) {
            if (this.isFocused) {
                this.currentValue = value;
            } else {
                this.currentValue = NumberFormat.formatToDisplay(value, this.numberFormat);
            }
        },
    },
    mounted() {
        this.currentValue = this.formatedValue;
    },
    methods: {
        handleInput($event) {
            this.$emit('input', $event);
            this.$emit('update:modelValue', this.formatToNumber($event.target.value));
        },
        handleFocus($event) {
            this.isFocused = true;
            this.$emit('focus', $event);
        },
        handleBlur($event) {
            this.isFocused = false;
            this.$emit('blur', $event);
            this.currentValue = this.formatedValue;
        },
        handleKeyupEnter($event) {
            this.isFocused = false;
            this.$emit('change', $event);
            this.$refs.compassInput.blur();
        },
        handleKeyPress($event) {
            const keyPressed = $event.key;
            const regexKeysAllowed = new RegExp(
                `[${this.numberDecimal}${this.numberThousand}0-9]`,
                'g',
            );

            if (!keyPressed.match(regexKeysAllowed)) {
                $event.preventDefault();
            }
        },
        formatToNumber(valueToFormat) {
            const valueFormated = valueToFormat
                .replace(this.numberThousand, '')
                .replace(this.numberDecimal, '.');

            return Number(valueFormated);
        },
    },
};
</script>
